
export const DEFAULT_LENGUAJE = "es";
export const API_URL = import.meta.env.VITE_API_INFRINGEMENTS_URL;
export const LOCALSTORAGEPARAMETERNAME = "Parameters";
//export const USERTOKENKEY = import.meta.env.VITE_SESSION_TOKEN;
export const CONFIG_CSS_INTERNALLOGIN = "CONFIG_CSS_InternalLogin";
export const URL_SUCCESS = API_URL + 'fines/payment-response';
export const URL_FAILURE = API_URL + 'fines/payment-response';
//Ruta en servidor
export const SERVER_ROUTE = "/";
export const PATH_FILE = "PATH_FILE";


export const STATUS_CODE_SERVER = {
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  OK: 200,
};

export const FormatCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const DateFormat = {
  DDMMYYYY: "dd/MM/yyyy",
  DDMMYYYYhhmm: "dd/MM/yyyy hh:mm aa",
  DDMMYYYYhhmmssAPI: "yyyy-MM-dd HH:mm:ss",
};